import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import utils from "../../../../utils";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
const DialogCupomDesconto = ({
  open,
  cdInput,
  cupomDescontoTipoList,
  handleClose,
  handleChange,
  validaCupom,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="max-width-dialog-title"
      fullWidth
    >
      <DialogContent>
        <DialogTitle
          style={{ textAlign: "center" }}
          id="max-width-dialog-title"
        >
          Cupom de desconto
        </DialogTitle>
        <Box p={2}>
          <Grid container spacing={2}>
            <Grid
              size={{
                xs: 12,
                md: 12,
              }}
              width="100%"
            >
              <TextField
                onChange={handleChange}
                value={cdInput.cupom || ""}
                variant="outlined"
                label="Cupom"
                placeholder="Ex: QRPEDIR10"
                name="cupom"
                required
                fullWidth
                style={{ marginBottom: "5px" }}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 12,
              }}
            >
              <FormControl required component="fieldset">
                <FormLabel component="legend" style={{ color: "black" }}>
                  Válido para:
                </FormLabel>
                <RadioGroup
                  row
                  name="tipoCupom"
                  value={cdInput.tipoCupom}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    style={{ marginTop: "-10px" }}
                    value="DELIVERY"
                    control={<Radio />}
                    label="Delivery"
                  />

                  <FormControlLabel
                    style={{ marginTop: "-10px" }}
                    value="LOCAL"
                    control={<Radio />}
                    label="Local"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <TextField
                fullWidth
                id="outlined-select-currency"
                select
                name="tipo"
                label="Tipo"
                required
                onChange={handleChange}
                value={cdInput.tipo || ""}
                variant="outlined"
              >
                {cupomDescontoTipoList.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid
              size={{
                xs: 6,
                md: 3,
              }}
            >
              <TextField
                type="number"
                variant="outlined"
                onChange={handleChange}
                value={cdInput.valor || ""}
                disabled={cdInput.tipo === "ENTREGA_GRATIS"}
                name="valor"
                fullWidth
                label={
                  cdInput.tipo === "PERCENTUAL_DA_CONTA"
                    ? "% Desconto"
                    : cdInput.tipo === "VALOR_FIXO"
                    ? utils.optionsCurrency().currencySymbol + "Desconto"
                    : "Entrega grátis"
                }
              />
            </Grid>
            <Grid
              size={{
                xs: 6,
                md: 3,
              }}
            >
              <TextField
                type="number"
                variant="outlined"
                onChange={handleChange}
                value={cdInput.pedidoValorMinimo || ""}
                name="pedidoValorMinimo"
                fullWidth
                label={utils.optionsCurrency().currencySymbol + "Ped. Mínimo"}
              />
            </Grid>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Grid
                size={{
                  xs: 12,
                  md: 6,
                }}
                width="100%"
              >
                <DateTimePicker
                  ampm={false}
                  label="Iniciar em"
                  inputFormat="yyyy/MM/dd HH:mm"
                  sx={{ width: "100%" }}
                  value={cdInput.inicio || null}
                  onChange={(date) =>
                    handleChange({
                      target: { name: "inicio", value: date },
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
              </Grid>

              <Grid
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <DateTimePicker
                  ampm={false}
                  label="Termina em"
                  inputFormat="yyyy/MM/dd HH:mm"
                  value={cdInput.termino || null}
                  sx={{ width: "100%" }}
                  onChange={(date) =>
                    handleChange({
                      target: { name: "termino", value: date },
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
              </Grid>
            </LocalizationProvider>
            <Grid
              size={{
                xs: 12,
                md: 12,
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    name="ignorarProdutosPromocao"
                    checked={cdInput.ignorarProdutosPromocao}
                    onChange={handleChange}
                  />
                }
                label="Ignorar produtos em promoção"
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="text"
          onClick={handleClose}
          startIcon={<CancelIcon />}
        >
          Cancelar
        </Button>

        <Button
          aria-expanded={true}
          variant="contained"
          color="secondary"
          onClick={validaCupom}
          startIcon={<SaveIcon />}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogCupomDesconto;
